
export const  importAllImagesInFolder = (requireContext) => {
  return requireContext.keys().map(requireContext);
};